

















































import mixins from 'vue-typed-mixins';
import { clean } from '../../utils/CommonUtils';
import { DataTableHeader } from 'vuetify';
export default mixins().extend({
  props: {
    'disable-search': {
      type: Boolean as () => boolean,
    },
  },
  computed: {
    attrs(): any {
      return {
        loading: !this.$attrs.items,
        'custom-sort': this.customSort,
        'footer-props': { 'items-per-page-options': [25, 50, 100] },
        ...this.$attrs,
        'custom-filter': null, // force to null, filtering handled by ozi-table
        search: null, // force to null, handled by ozi-table
        headers: null, // force to null, handled by ozi-table
        items: null, // force to null, handled in this component
        'calculate-widths': true,
        locale: this.$session?.language,
      };
    },

    listeners(): any {
      return {
        ...this.$listeners,
      };
    },

    headers(): DataTableHeader[] {
      const headers: DataTableHeader[] = Array.from(this.$attrs.headers) as any;
      if (this.$scopedSlots['item._actions']) {
        headers.push({
          text: this.$i18n.tc('app.label.action', 2),
          value: '_actions',
          sortable: false,
          filterable: false,
        });
      }
      return headers;
    },

    // format headers to be used as dynamic slot names
    headerscopes(): any {
      return (this.$attrs?.headers as any)?.map((header: DataTableHeader) => ({
        path: header.value,
        scopename: 'item.' + header.value,
        header: header,
      }));
    },

    items(): any {
      // do not use vuetify filtering as it doesn't work the exact way we want
      if ((this.$options.propsData as any).disableSearch) {
        return this.$attrs.items;
      } else {
        return (this.$attrs.items as any)?.filter((item: any) =>
          this.headerscopes.some((scope: any) => {
            if (!clean(this.$attrs.search || this.search)) {
              return true;
            } else {
              const display = clean(this.genericDisplay(scope.path, item));
              if (
                scope.header.filter !== undefined &&
                typeof scope.header.filter === 'function'
              ) {
                // call the passed filter function for the header if it is provided for manual filtering
                return scope.header.filter(
                  display,
                  clean(this.$attrs.search || this.search),
                  item
                );
              } else {
                return display?.includes(
                  clean(this.$attrs.search || this.search) || ''
                );
              }
            }
          })
        );
      }
    },
  },
  data(): {
    search: string;
  } {
    return {
      search: '',
    };
  },
  methods: {
    genericDisplay(path: any, item: any): any {
      const split = path.split('.');
      const key = split?.shift();
      const value = item[key];
      if (split.length > 0 && value) {
        if (Array.isArray(value)) {
          return value
            .map((val) => this.genericDisplay(split.join('.'), val))
            ?.join(', ');
        } else {
          return this.genericDisplay(split.join('.'), value);
        }
      } else {
        return this.text(value);
      }
    },

    text(item?: any): string | undefined {
      if (item === undefined || item === null) {
        return '';
      } else if (typeof item === 'string') {
        return item;
      } else if (Array.isArray(item)) {
        return item?.map((i) => this.text(i)).join(', ');
      } else if (typeof item === 'object') {
        // it's possible that this is a LanguageObject so attempt to filter the translations
        if (item.en !== undefined && item.fr !== undefined) {
          return this.$translate(item) as string;
        }
      }
      return JSON.stringify(item);
    },

    customFilter(item: any, search: string) {
      return this.headerscopes.some((scope: any) => {
        const display = clean(this.genericDisplay(scope.path, item));
        if (
          scope.header.filter !== undefined &&
          typeof scope.header.filter === 'function'
        ) {
          // call the passed filter function for the header if it is provided for manual filtering
          return scope.header.filter(display, clean(search), item);
        } else {
          return display?.includes(clean(search) || '');
        }
      });
    },

    customSort(
      items: any[],
      sortBy: string[],
      sortDesc: boolean[],
      locale: string,
      customSorters?: any
    ) {
      if (
        customSorters &&
        customSorters[sortBy[0]] &&
        typeof customSorters[sortBy[0]] === 'function'
      ) {
        return customSorters[sortBy[0]](
          items,
          sortBy,
          sortDesc,
          locale,
          customSorters
        );
      } else {
        return items?.sort((a, b) => {
          if (sortBy[0]) {
            const cleanA = (typeof a[sortBy[0]] === 'number') 
              ? a[sortBy[0]]
              : clean(this.genericDisplay(sortBy[0], a)) || '';
            const cleanB = (typeof b[sortBy[0]] === 'number') 
              ? b[sortBy[0]]
              : clean(this.genericDisplay(sortBy[0], b)) || '';
            if (cleanA > cleanB) {
              return sortDesc[0] ? 1 : -1;
            } else if (cleanA < cleanB) {
              return sortDesc[0] ? -1 : 1;
            }
          }
          return 0;
        });
      }
    },
  },
});
